<template>
  <div class="project">
    <div class="header">
      <div class="header-content-box">
        <div class="header-left">
          <div class="title">项目</div>
        </div>
        <div class="header-meddle">
          <p v-show="showDirectMessage">www.bitahub.com本月将停用，请使用新域名
            <a href="https://bitahub.ustc.edu.cn" target="_blank">bitahub.ustc.edu.cn</a>
          </p>
        </div>
        <div class="header-right">
          <div class="action-box">
            <div class="header-button basebtn">
              <button class="basebtn-common lan" @click="createProject">+ 创建项目</button>
            </div>
          </div>
        </div>
      </div>
      <div class="header-nav-list">
        <ul class="nav-list">
          <li class="main-nav-list nav-left clearfix">
            <ul class="main-nav-list-container">
              <li class="nav-item link-item" :class="{'active': activeTab === 1}" @click="toggleActive(1)">
                <i class="icon" :class="{'icon-project-active': activeTab === 1, 'icon-project-disactive': activeTab === 2}"></i>项目视图
              </li>
              <li class="nav-item link-item" :class="{'active': activeTab === 2}" @click="toggleActive(2)">
                <i class="icon" :class="{'icon-task': activeTab === 1, 'icon-active-task': activeTab === 2}"></i>任务视图
              </li>
            </ul>
          </li>
        </ul>
        <div class="storageTipsDiv">
          <p class="tips" v-show="showStorageTip">
            <a target="_blank" href="/index" class="target">
              {{storageTips}}
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { getUserStorageInfo } from '../../api/project'
export default {
  data () {
    return {
      // 当前激活tab页
      // activeTab: 1
      showStorageTip: false,
      // 展示跳转地址
      showDirectMessage: false,
      storageTips: '的存储空间不足'
    }
  },
  methods: {
    // tab页切换
    toggleActive (val) {
      if (val === 1) {
        this.$router.push({ path: '/project/list' })
      } else {
        this.$router.push({ path: '/project/task' })
      }
    },
    showDirectMessageOrNot () {
      let url = location.href
      if (url.indexOf('bitahub.com') !== -1) {
        this.showDirectMessage = true
      }
    },
    // 创建项目
    createProject () {
      this.$router.push('/project/create')
    },
    // 是否展示存储信息
    storageTipsShow () {
      let that = this
      getUserStorageInfo().then(res => {
        if (res.message.code === 0) {
          let result = ''
          let usedData = res.data.used
          let quodaData = res.data.quota
          let projectNumPer = usedData.projects[0] / quodaData.projects[0]
          let projectStoragePer = usedData.projects[1] / quodaData.projects[1]
          let datasetNumPer = usedData.datasets[0] / quodaData.datasets[0]
          let datasetStoragePer = usedData.datasets[1] / quodaData.datasets[1]
          let modelNumPer = usedData.models[0] / quodaData.models[0]
          let modelStoragePer = usedData.models[1] / quodaData.models[1]
          if (projectNumPer > 0.8 || projectStoragePer > 0.8) {
            result = '项目'
          }
          if (datasetNumPer > 0.8 || datasetStoragePer > 0.8) {
            result = result + ',数据集'
          }
          if (modelNumPer > 0.8 || modelStoragePer > 0.8) {
            result = result + ',模型'
          }
          if (result) {
            if (result.startsWith(',')) {
              result = result.substring(1, result.length)
            }
            that.storageTips = result + that.storageTips
            that.showStorageTip = true
          }
        }
      })
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.storageTipsShow()
    this.showDirectMessageOrNot()
  },
  computed: {
    activeTab: {
      get: function () {
        if (this.$route.path === '/project/list') {
          return 1
        } else {
          return 2
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.project
  display flex
  flex-flow column
  .header
    background #f4f7f8
    .header-nav-list
      display flex
      width 100%
      margin 0 auto
      max-width 1162px
      padding 0
      .storageTipsDiv
        text-align right
        width 50%
        .tips
          line-height 37px
          .target
            color #f56c6c
            text-decoration none
            font-size 18px
            font-style italic
            font-weight bolder
    .header-content-box
      display flex
      width 100%
      margin 0 auto
      max-width 1162px
      padding 20px 0
      .header-left
        width 25%
        .title
          font-weight 600
          font-size 28px
          color #2D323B
          letter-spacing 0
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
      .header-meddle
        width 50%
        color red
        font-size 20px
        font-weight 400
      .header-right
        width 25%
        .action-box
          display flex
          justify-content flex-end
    .nav-list
      width 100%
      position relative
      margin 0 auto
      max-width 1162px
      display flex
      .main-nav-list
        height 100%
        .main-nav-list-container
          display flex
          height 100%
          align-items flex-end
          .nav-item
            padding 0 10px
            font-weight 600
            font-size 14px
            display flex
            color #666
            justify-content center
            align-items center
            cursor pointer
            position relative
            margin 0
            >a
              text-decoration none
              cursor pointer
            >a:before
              content ''
              position absolute
              top 0
              right 0
              bottom 0
              left 0
          .link-item
            padding 0 15px
            height 44px
            .icon
              display inline-block
              width 30px
              height 50px
            .icon-project-active
              background url(../../common/image/icon/icon-pro-list-active.png) no-repeat center
              // background url(../../common/image/icon-all.png) no-repeat
              // background-position -204px -348px
              background-size 13px 14px
            .icon-project-disactive
              background url(../../common/image/icon/icon-pro-list-disactive.png) no-repeat center
              background-size 13px 14px
            .icon-task
              background url(../../common/image/icon/task.png) no-repeat center
              background-size 13px 14px
            .icon-active-task
              background url(../../common/image/icon/active-task.png) no-repeat center
              background-size 13px 14px
        .nav-item.active
          font-weight bold
          color #2d323b
          background #fff
          box-shadow 0 14px 0 -10px #f3c922 inset
          border-radius 5px 5px 0 0
    .nav-left
      width 40%
    .nav-right
      width 60%
      display flex
      align-items center
      justify-content flex-end
  .content
    flex 1
    width 100%
    position relative
    margin 0 auto
    max-width 1162px
</style>
